// extracted by mini-css-extract-plugin
export default {"main":"feed_main__bRClU","order":"feed_order__GhZ6p","header":"feed_header__9B-kv"};